import script from "./ReceiptDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReceiptDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ReceiptDetail.vue?vue&type=style&index=0&id=b6342e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6342e28"]])

export default __exports__